module.exports = __webpack_public_path__ + "img/mart1.752a8562.jpeg";